import Vue from 'vue'
import VueRouter from 'vue-router'
import {buscarUrl} from '@/plugins/shared'
import {routerCliente} from '@/modules/clientes/router'
import {routes_proveedores} from '@/modules/proveedores/router'
import {alcaldiasRouter} from '@/modules/alcaldias/router'
import {routes_publicaciones} from '@/modules/procesos/router'
import {proyectosRouter} from '@/modules/proyectos/router'
import {routes_empresas_revision} from '@/modules/proveedores/pages/revision/revision_router'
import {router_mantenimiento} from "@/modules/procesos/pages/mantenimiento/router_mantenimiento";
import {routes_administracion} from "@/modules/administracion/router";
import {routes_help} from "@/modules/help/router";
import {institutionsRouter} from '@/modules/institutions/router'
import {vistasRouter} from "@/modules/visitas/router";
import {acquisitionRouter} from "@/modules/acquisitions/router";
import {routes_publicaciones_previas} from '@/modules/previas/router'
import {router_mantenimiento_previas} from "@/modules/previas/pages/mantenimiento/router_mantenimiento";
import {processRequestRouter} from "@/modules/processRequest/router";

Vue.use(VueRouter)

const routes = [
  ...routerCliente,
  ...routes_proveedores,
  ...routes_publicaciones,
  ...routes_publicaciones_previas,
  {
    path: '/login',
    name: 'Login',
    component: () => import('../layout/login.vue')
  }, {
    path: '/',
    component: () => import('../layout/layout.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('../views/inicio')
      },
      ...alcaldiasRouter,
      ...proyectosRouter,
      ...vistasRouter,
      ...acquisitionRouter,
      ...routes_empresas_revision,
      ...router_mantenimiento,
      ...routes_administracion,
      ...routes_help,
      ...institutionsRouter,
      ...router_mantenimiento_previas,
      ...processRequestRouter,
      {
        path: '/perfil',
        name: 'perfil',
        component: () => import( '../layout/perfil')
      },
      {
        path: '/fondos-direccion',
        name: 'fondos-direccion',
        component: () => import( '../layout/fondos_direccion')
      },
      {
        path: '/empresa_extrajera/registro/:id',
        name: 'empresa-registro',
        component: () => import( '../modules/proveedores/pages/internacional/index_registro')
      },
    ]
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( '../views/About.vue')
  },
  {
    path: '/reset-password/:id',
    name: 'reset-password',
    component: () => import( '../layout/reestablecer_contrasenia')
  },
  {
    path: '/recuperar',
    name: 'recuperar',
    component: () => import( '../layout/recuperar_contraseña')
  },
  {
    path: '/prueba',
    name: 'prueba',
    component: () => import( '../modules/proveedores/pages/tecnicos/visita_tecnica_empresa')
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: () => import('../layout/forbidden')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

router.beforeEach(async (to, from, next) => {
  let searchURl = await buscarUrl(to.fullPath, from.fullPath)
  if (searchURl) {
    if (localStorage.urlRedirect)
      if (localStorage.urlRedirect === to.fullPath)
        localStorage.removeItem('urlRedirect');
    next()
  } else {
    localStorage.urlRedirect = to.fullPath
    if (localStorage.token) {
      next({name: 'home'})
    } else {
      next({name: 'Login'})
    }
  }
})

export default router
